import * as React from 'react';
import ReactQuill from 'react-quill';

const modules: any = {
  toolbar: [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline','strike', 'blockquote'],
    [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
    ['link'],
    ['clean']
  ],
};

const formats: any = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image'
];

const QuillEditor = ({ value, onChange, label }: any) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <ReactQuill
        theme="snow"
        modules={modules}
        formats={formats}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}

export default QuillEditor;



// WEBPACK FOOTER //
// ./src/components/Shared/QuillEditor.tsx